import { render } from "./Terms.vue?vue&type=template&id=720343da"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/Realgestion/rg-massive-camoruco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__